import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, m } from 'motion/react';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
import { Header } from './Header';
import { Toaster } from '@/components/ui';
import { TransactionComposer } from '@/features/transactions/TransactionComposer';
import { SupportIntroBanner } from '@/features/support/SupportReporter';
import { SimpleSupportReporter } from '@/features/support/SimpleSupportReporter';
import { useComposeStore } from '@/stores/compose';

const EASE = [0.16, 1, 0.3, 1] as const;

/** Casca do app: rail (desktop) + bottom nav (mobile) + header, com transição de página. */
export function AppShell() {
  const location = useLocation();
  const openTypeSheet = useComposeStore((s) => s.openTypeSheet);
  const [supportOpen, setSupportOpen] = useState(false);

  // FAB abre o seletor de tipo de lançamento, ancorado no botão.
  const handleFab = (anchor: DOMRect) => openTypeSheet(anchor);

  return (
    <div className="min-h-dvh bg-canvas">
      <Sidebar onFab={handleFab} onSupport={() => setSupportOpen(true)} />

      <div className="lg:pl-20">
        <Header onSupport={() => setSupportOpen(true)} />
        <SupportIntroBanner />

        <AnimatePresence mode="wait">
          <m.main
            key={location.pathname}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2, ease: EASE }}
            className="mx-auto w-full min-w-0 max-w-[82rem] px-3 pb-[calc(6.5rem+env(safe-area-inset-bottom))] pt-5 min-[375px]:px-4 lg:px-8 lg:pb-10 lg:pt-6"
          >
            <Outlet />
          </m.main>
        </AnimatePresence>
      </div>

      <BottomNav onFab={handleFab} />
      <SimpleSupportReporter open={supportOpen} onClose={() => setSupportOpen(false)} />
      <TransactionComposer />
      <Toaster />
    </div>
  );
}
